{
  "COMPOSE_REDIRECT": {
    "OPENING": "Új beszélgetés megnyitása vele: {email}…",
    "NO_EMAIL": "Nincs megadva e-mail-cím. Használja ezt: ?email=name@example.com",
    "CONTACT_ERROR": "Nem sikerült megtalálni a kontaktot ehhez: {email}."
  },
  "CONVERSATION": {
    "IMAGE_RESIZE": {
      "SMALL": "Kicsi",
      "MEDIUM": "Közepes",
      "LARGE": "Nagy",
      "ORIGINAL": "Eredeti"
    },
    "SHOW_HIDDEN_MESSAGES": "Rejtett üzenetek megjelenítése",
    "SELECT_A_CONVERSATION": "Kérjük válassz egy beszélgetést a bal sávból",
    "CSAT_REPLY_MESSAGE": "Kérlek értékeld a beszélgetést",
    "404": "Elnézést, a beszélgetés nem található. Kérlek, próbáld újra",
    "SWITCH_VIEW_LAYOUT": "Elrendezés megváltoztatása",
    "DASHBOARD_APP_TAB_MESSAGES": "Üzenetek",
    "UNVERIFIED_SESSION": "A felhasználó személyazonossága nincs hitelesítve",
    "NO_MESSAGE_1": "Jajj ne! Úgy tűnik, hogy nincs több ügyfélbeszélgetés az inboxodban.",
    "NO_MESSAGE_2": "egy üzenet küldéséhez az oldaladra!",
    "NO_INBOX_1": "Hola! Úgy tűnik, hogy még nem adtál hozzá fiókokat.",
    "NO_INBOX_2": " Első lépések",
    "NO_INBOX_AGENT": "O-Ó! Úgy tűnik, hogy egyetlen fióknak sem vagy tagja. Kérjük lépj kapcsolatba az adminisztrátoroddal",
    "SEARCH_MESSAGES": "Üzenetek keresése a beszélgetésekben",
    "VIEW_ORIGINAL": "Eredeti megtekintése",
    "VIEW_TRANSLATED": "Fordítás megtekintése",
    "TRANSLATION": "Fordítás",
    "EMPTY_STATE": {
      "CMD_BAR": "menü megnyitása",
      "KEYBOARD_SHORTCUTS": "billentyűparancs megtekintése"
    },
    "SEARCH": {
      "TITLE": "Üzenetekben keresés",
      "RESULT_TITLE": "Keresés eredménye",
      "LOADING_MESSAGE": "Adatelemzés...",
      "PLACEHOLDER": "Írj be szöveget hogy keress az üzenetek közt",
      "NO_MATCHING_RESULTS": "Nincs találat."
    },
    "TRANSCRIPT": {
      "SHOW": "Teljes átirat megjelenítése",
      "HIDE": "Teljes átirat elrejtése",
      "DOWNLOAD": "Átirat letöltése",
      "COPY": "Átirat másolása"
    },
    "INVISIBLE_TO_CUSTOMER": "Az ügyfél számára láthatatlan",
    "SENT_VIA_EMAIL": "A kapcsolattartónak e-mailben is elküldve ({time})",
    "UNREAD_MESSAGES": "Olvasatlan üzenetek",
    "UNREAD_MESSAGE": "Olvasatlan üzenet",
    "CLICK_HERE": "Kattints ide",
    "LOADING_INBOXES": "Postaládák betöltése",
    "LOADING_CONVERSATIONS": "Beszélgetések betöltése",
    "CANNOT_REPLY": "Nem tudunk válaszolni, mivel",
    "24_HOURS_WINDOW": "24 órás üzeneti ablak megkötés",
    "API_HOURS_WINDOW": "Erre a beszélgetésre csak {hours} órán belül tud válaszolni",
    "FACEBOOK_CANNOT_REPLY": "Ha folytatni szeretné ezt a beszélgetést, ",
    "NOT_ASSIGNED_TO_YOU": "Ez a beszélgetés nincs hozzádrendelve. Szeretnéd magadhoz rendelni?",
    "ASSIGN_TO_ME": "Hozzárendelés magamhoz",
    "PENDING_WITH_BOT_BANNER": "Ezt a beszélgetést AI bot kezeli. Ha válaszolni szeretne, először nyissa meg a beszélgetést.",
    "INBOX_DELETE_REQUESTED_BANNER": "Ez a postafiók törlésre van megjelölve, ezért az ügyfél válasza soha nem érkezne meg. A válaszadáshoz helyezze át a beszélgetést egy másik postafiókba.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Ennek a kapcsolattartónak van egy másik nyitott beszélgetése #{id}",
      "MULTIPLE": "Ennek a kapcsolattartónak további nyitott beszélgetései vannak ({count})",
      "OPEN": "Megnyitás",
      "SHOW": "Megjelenítés"
    },
    "TWILIO_WHATSAPP_CAN_REPLY": "Erre a beszélgetésre csak konzerv válasszal válaszolhatsz, mert",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 órás üzeneti ablak megkötés",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Ez az Instagram fiók át lett migrálva az új Instagram csatornás postafiókba. Minden új üzenet ott fog megjelenni. Ebből a beszélgetésből már nem tud üzenetet küldeni.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Nem lehet üzenetet küldeni, mert az ügyfél nincs online, és az e-mail folytonosság nem elérhető.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "Az ügyfél nincs online. Lehet, hogy nem kapja meg az üzeneteket, mivel az e-mail folytonosság nem elérhető.",
    "REPLYING_TO": "Neki válaszolsz:",
    "REMOVE_SELECTION": "Kijelölés törlése",
    "DOWNLOAD": "Letöltés",
    "OPEN_FILE": "Megnyitás",
    "DOWNLOAD_ATTACHMENTS": "Összes letöltése",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Összes melléklet letöltése egyenként",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Összes letöltése ZIP-ként",
    "ERROR_DOWNLOADING_FILE": "Hiba a fájl letöltésekor",
    "UNKNOWN_FILE_TYPE": "Ismeretlen fájl",
    "SAVE_CONTACT": "Kontakt mentése",
    "NO_CONTENT": "Nincs megjeleníthető tartalom",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Küldés előtt végezze el:",
      "EXECUTE": "Végrehajtás",
      "RETRY": "Újrapróbálás",
      "CONFIRM": "Végrehajtja most?",
      "CONFIRM_YES": "Igen, végrehajtás",
      "CONFIRM_NO": "Mégse",
      "RUNNING": "Folyamatban…",
      "DONE": "Kész",
      "CLAIM_DELAYED": "a rendelés kézbesítése után kerül benyújtásra",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "ÚJ reklamáció jött létre: {reference}, mert a(z) {planned} lezárult — módosítsa a piszkozat szövegét",
        "NEW_CLAIM": "ÚJ reklamáció jött létre: {reference} a(z) {planned} frissítése helyett — módosítsa a piszkozat szövegét",
        "OTHER_CLAIM": "A(z) {reference} reklamáció frissült a(z) {planned} helyett — módosítsa a piszkozat szövegét",
        "EXISTING_CLAIM": "Új reklamáció nem jött létre, a meglévő {reference} frissült — módosítsa a piszkozat szövegét",
        "OTHER": "Ez a piszkozatban feltételezettől eltérően történt — módosítsa a piszkozat szövegét"
      },
      "FAILED": "Sikertelen",
      "UNREACHABLE": "A bot nem érhető el",
      "REQUEST_FAILED": "A műveletet nem sikerült elindítani, kérjük, próbálja újra.",
      "ACTIONS": {
        "CANCEL_ORDER": "Mondja le a rendelést",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Módosítsa a fizetést utánvétre",
        "CREATE_CLAIM": "Nyújtson be reklamációt",
        "CREATE_OR_UPDATE_CLAIM": "Nyújtson be vagy frissítsen reklamációt",
        "EXTEND_ORDER_PICKUP_DATE": "Hosszabbítsa meg az átvételi határidőt"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} megosztott egy kontaktot",
      "LOCATION": "{sender} megosztott egy helyet",
      "FILE": "{sender} megosztott egy fájlt"
    },
    "UPLOADING_ATTACHMENTS": "Csatolt fileok feltöltése...",
    "REPLIED_TO_STORY": "Válaszolt a storydra",
    "UNSUPPORTED_MESSAGE": "Ez az üzenet nem támogatott. Az üzenetet a Facebook / Instagram alkalmazásban tekintheti meg.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Ez az üzenet nem támogatott. Ezt az üzenetet a Facebook Messenger alkalmazásban tekintheti meg.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Ez az üzenet nem támogatott. Ezt az üzenetet az Instagram alkalmazásban tekintheti meg.",
    "SUCCESS_DELETE_MESSAGE": "Üzenet törölve",
    "FAIL_DELETE_MESSSAGE": "Nem tudtad törölni az üzenetet! Próbáld újra",
    "NO_RESPONSE": "Nincs válasz",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Kérd meg az ügyfelet, hogy ossza meg a WhatsApp telefonszámát",
      "PENDING_ACTION": "Elérhetőségi adatok kérése folyamatban",
      "STATES": {
        "PENDING": "Várakozás elérhetőségi adatokra",
        "SHARED": "Telefonszám megosztva",
        "IDENTITY_CONFLICT": "Telefonszám ellenőrzést igényel"
      }
    },
    "RESPONSE": "Válasz",
    "RATING_TITLE": "Értékelés",
    "FEEDBACK_TITLE": "Visszajelzés",
    "REPLY_MESSAGE_NOT_FOUND": "Üzenet nem elérhető",
    "CARD": {
      "SHOW_LABELS": "Cimkék mutatása",
      "HIDE_LABELS": "Cimkék elrejtése"
    },
    "HEADER": {
      "MORE": "További műveletek",
      "RESOLVE_ACTION": "Megoldva",
      "REOPEN_ACTION": "Újranyitás",
      "OPEN_ACTION": "Megnyitás",
      "OPEN": "Tovább",
      "CLOSE": "Bezárás",
      "DETAILS": "részletek",
      "SNOOZED_UNTIL": "Halasztás eddig",
      "SNOOZED_UNTIL_TOMORROW": "Halasztás holnapig",
      "SNOOZED_UNTIL_NEXT_WEEK": "Halasztás jövő hétig",
      "SNOOZED_UNTIL_NEXT_REPLY": "Halasztás következő válaszig",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "elmulasztva",
        "DUE": "esedékes"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Függőben levőként megjelölés",
      "SNOOZE_UNTIL": "Halasztás",
      "RESOLVE_WITHOUT_CSAT": "Lezárás CSAT nélkül",
      "SNOOZE": {
        "TITLE": "Halasztás eddig",
        "NEXT_REPLY": "Következő válasz",
        "TOMORROW": "Holnap",
        "NEXT_WEEK": "Jövő héten"
      }
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Halasztás eddig",
      "APPLY": "Halasztás",
      "CANCEL": "Mégse"
    },
    "PRIORITY": {
      "TITLE": "Prioritás",
      "OPTIONS": {
        "NONE": "Nincs",
        "URGENT": "Sürgős",
        "HIGH": "Magas",
        "MEDIUM": "Közepes",
        "LOW": "Alacsony"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Nincs",
        "INPUT_PLACEHOLDER": "Prioritás megadása",
        "NO_RESULTS": "Nincs találat",
        "SUCCESSFUL": "A(z) {conversationId} azonosítójú beszélgetés prioritása módosítva erre: {priority}",
        "FAILED": "Nem sikerült megváltoztatni a prioritást. Kérlek, próbáld újra."
      }
    },
    "SLA": {
      "BREACHED": "megszegve"
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Megnyitás új lapon",
      "COPY_LINK": "Beszélgetés hivatkozásának másolása",
      "COPY_LINK_SUCCESS": "A beszélgetés hivatkozása a vágólapra másolva",
      "PENDING": "Függőben levőként megjelölés",
      "RESOLVED": "Megjelölés megoldottként",
      "MARK_AS_UNREAD": "Megjelölés olvasatlanként",
      "MARK_AS_READ": "Megjelölés olvasottként",
      "REOPEN": "Beszélgetés újranyitása",
      "SNOOZE": {
        "TITLE": "Halasztás",
        "NEXT_REPLY": "Következő válaszig",
        "TOMORROW": "Holnapig",
        "NEXT_WEEK": "Jövő hétig"
      },
      "ASSIGN_AGENT": "Ügynök hozzárendelése",
      "ASSIGN_LABEL": "Cimke hozzáadása",
      "AGENTS_LOADING": "Ügynökök betöltése...",
      "ASSIGN_TEAM": "Csapat hozzárendelése",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "A(z) {conversationId} azonosítójú beszélgetés hozzárendelve: „{agentName}”",
          "FAILED": "Nem sikerült hozzárendelni ügynököt. Kérlek, próbáld újra."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "A(z) #{labelName} címke hozzárendelve a(z) {conversationId} azonosítójú beszélgetéshez",
          "FAILED": "Nem sikerült hozzárendelni címkét. Kérlek, próbáld újra."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "A(z) „{team}” csapat hozzárendelve a(z) {conversationId} azonosítójú beszélgetéshez",
          "FAILED": "Nem sikerült hozzárendelni csoporthoz. Kérlek, próbáld újra."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Üzenet aláírás",
      "ENABLE_SIGN_TOOLTIP": "Aláírás bekapcsolása",
      "DISABLE_SIGN_TOOLTIP": "Aláírás kikapcsolása",
      "INSERT_SIGNATURE": "Aláírás beszúrása a szerkesztőbe",
      "SIGNATURE_PREVIEW_IMAGE": "(kép aláírás)",
      "MSG_INPUT": "Shift + enter új sorért. Kezdj a '/'-el mentett válasz kiválasztásához.",
      "PRIVATE_MSG_INPUT": "Shift + enter új sorért. Ezt csak ügynökök láthatják",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Üzenet aláírása nem változott, kérlek, változtasd meg a profilod beállításaiban. ",
      "CLICK_HERE": "Frissítéshez kattints ide",
      "WHATSAPP_TEMPLATES": "Whatsapp sablonok",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "A 24 órás WhatsApp-ablak lejárt. Válaszolj sablonüzenettel."
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Úgy tűnik, a válaszod {draftLanguage} nyelvű, de ez a beszélgetés {conversationLanguage} nyelvű.",
      "TRANSLATE_DRAFT": "Fordítás",
      "REPLY": "Válasz",
      "PRIVATE_NOTE": "Privát üzenet",
      "SEND": "Elküldés",
      "SEND_EMAIL": "E-mail küldése",
      "SEND_SMS": "SMS küldése",
      "NO_SMS_INBOX": "SMS-válaszok küldéséhez adjon hozzá egy SMS-postafiókot.",
      "SEND_CHAT": "Csevegés küldése",
      "CREATE": "Megjegyzés hozzáadása",
      "INSERT_READ_MORE": "Tudj meg többet",
      "DISMISS_REPLY": "Válasz elutasítása",
      "REPLYING_TO": "Válaszolva a következőre:",
      "REPLY_TO_THIS": "Válasz erre",
      "TIP_EXPAND_ICON": "Szerkesztő nagyítása",
      "TIP_COLLAPSE_ICON": "Szerkesztő kicsinyítése",
      "TIP_FORMAT_ICON": "Rich szövegszerkesztő mutatása",
      "HEADING_LEVEL": {
        "LABEL": "Szövegstílus",
        "NORMAL": "Normál szöveg",
        "H1": "Címsor 1",
        "H2": "Címsor 2",
        "H3": "Címsor 3"
      },
      "EDITOR": {
        "BOLD": "Félkövér",
        "ITALIC": "Dőlt",
        "UNDERLINE": "Aláhúzott",
        "TEXT_COLOR": "Szövegszín",
        "BG_COLOR_LABEL": "Háttérszín",
        "FONT_SIZE_LABEL": "Betűméret",
        "FONT_SIZE": {
          "XS": "Kicsi",
          "SM": "Közepesen kicsi",
          "MD": "Alapértelmezett",
          "LG": "Nagy",
          "XL": "Extra nagy",
          "XXL": "Hatalmas"
        },
        "CODE": "Kód",
        "LINK": "Link hozzáadása vagy eltávolítása",
        "CREATE_LINK": "Link létrehozása",
        "SAVE_LINK": "Mentés",
        "CANCEL": "Mégse",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Visszavonás",
        "REDO": "Újra",
        "BULLET_LIST": "Felsorolás",
        "ORDERED_LIST": "Számozott lista",
        "BLOCKQUOTE": "Idézet",
        "H1": "Címsor 1",
        "H2": "Címsor 2",
        "H3": "Címsor 3",
        "IMAGE_UPLOAD": "Kép feltöltése",
        "CLEAR_FORMATTING": "Formázás törlése",
        "COLOR": {
          "RED": "Piros",
          "YELLOW": "Sárga",
          "BLUE": "Kék",
          "ROSE_RED": "Rózsapiros",
          "DEEP_CYAN": "Sötét ciánkék",
          "ORANGE": "Narancs",
          "PISTACHIO": "Pisztácia",
          "PURPLE": "Lila",
          "FUCHSIA": "Fukszia",
          "SILVER": "Ezüst",
          "NAVY": "Sötétkék",
          "OLD_PINK": "Fáradt rózsaszín",
          "AQUA": "Akvamarin",
          "BROWN": "Barna",
          "OLIVE": "Olíva",
          "GOLD": "Arany",
          "BEIGE": "Bézs",
          "WINE": "Bordó",
          "FOREST": "Erdőzöld",
          "GREEN": "Zöld",
          "BLUE_GREY": "Kékesszürke",
          "RUBY_RED": "Rubinvörös",
          "CHESTNUT_BROWN": "Gesztenyebarna",
          "ASH_GREY": "Hamuszürke"
        },
        "BG_COLOR": {
          "RED": "Piros",
          "YELLOW": "Sárga",
          "BLUE": "Kék",
          "ROSE_RED": "Rózsapiros",
          "DEEP_CYAN": "Sötét ciánkék",
          "ORANGE": "Narancs",
          "PISTACHIO": "Pisztácia",
          "PURPLE": "Lila",
          "FUCHSIA": "Fukszia",
          "SILVER": "Ezüst",
          "NAVY": "Sötétkék",
          "OLD_PINK": "Fáradt rózsaszín",
          "AQUA": "Akvamarin",
          "BROWN": "Barna",
          "OLIVE": "Olíva",
          "GOLD": "Arany",
          "BEIGE": "Bézs",
          "WINE": "Bordó",
          "FOREST": "Erdőzöld",
          "GREEN": "Zöld",
          "BLUE_GREY": "Kékesszürke",
          "RUBY_RED": "Rubinvörös",
          "CHESTNUT_BROWN": "Gesztenyebarna",
          "ASH_GREY": "Hamuszürke"
        }
      },
      "TIP_EMOJI_ICON": "Emoji választó mutatása",
      "TIP_ATTACH_ICON": "Fileok csatolása",
      "TIP_AUDIORECORDER_ICON": "Hangfelvétel",
      "TIP_AUDIORECORDER_PERMISSION": "Hozzáférés megadása a hangfelvételhez",
      "TIP_AUDIORECORDER_ERROR": "Nem sikerült megnyitni a hangfelvételt",
      "DRAG_DROP": "Helyezd ide a csatolmányt",
      "START_AUDIO_RECORDING": "Hangfelvétel indítása",
      "STOP_AUDIO_RECORDING": "Hangfelvétel leállítása",
      "EMAIL_HEAD": {
        "EDIT": "Szerkesztés",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Elrejtés",
        "INCLUDE_ORIGINAL_MESSAGE": "Eredeti üzenet csatolása",
        "TO": "Címzett",
        "ADD_BCC": "Titkos másolat hozzáadása",
        "EDIT_HEADERS": "Szerkesztés",
        "HIDE_HEADER_EDITS": "Szerkesztések elrejtése",
        "CC": {
          "LABEL": "Másolat",
          "PLACEHOLDER": "E-mail vesszőkkel elválasztva",
          "ERROR": "Kérlek, adj meg érvényes e-mail címet"
        },
        "BCC": {
          "LABEL": "Titkos másolat",
          "PLACEHOLDER": "E-mail vesszőkkel elválasztva",
          "ERROR": "Kérlek, adj meg érvényes e-mail címet"
        },
        "SUBJECT": {
          "LABEL": "TÁRGY",
          "PLACEHOLDER": "E-mail tárgya",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Definiálatlan változók",
        "MESSAGE": "Definiálatlan változók vannak az üzenetedben. Így is el szeretnéd küldeni az üzenetet?",
        "CONFIRM": {
          "YES": "Elküldés",
          "CANCEL": "Mégse"
        }
      },
      "COPILOT": {
        "Q": "Kérjen segítséget a robottól"
      },
      "": ""
    },
    "VISIBLE_TO_AGENTS": "Privát megjegyzés: csak Neked és a csapat tagjainak látható",
    "CHANGE_STATUS": "A beszélgetés státusza megváltozott",
    "CHANGE_STATUS_FAILED": "A beszélgetés státuszának megváltoztatása sikertelen",
    "CHANGE_AGENT": "Hozzárendelt ügynök megváltoztatva",
    "CHANGE_AGENT_FAILED": "Felelős megváltoztatása sikertelen",
    "ASSIGN_LABEL_SUCCESFUL": "Címke sikeresen hozzárendelve",
    "ASSIGN_LABEL_FAILED": "Címke hozzárendelése sikertelen",
    "CHANGE_TEAM": "A beszélgetés csapata megváltozott",
    "IMAGE_UPLOAD_ERROR": "Nem sikerült feltölteni a képet, kérjük, próbálja újra",
    "FILE_SIZE_LIMIT": "A file mérete meghaladja a {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} limitet",
    "DRAFT": {
      "FILE_TOO_LARGE": "A '{fileName}' fájl ({fileSize}) túl nagy a piszkozat tárolásához, és kihagyásra kerül",
      "ATTACHMENT_SERIALIZATION_FAILED": "Nem sikerült a melléklet szerializálása a piszkozat tárolásához",
      "STORAGE_QUOTA_EXCEEDED": "Tárhelykvóta túllépve. A piszkozat mellékletek nélkül került mentésre",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Nem sikerült menteni a piszkozatot mellékletek nélkül sem",
      "SAVE_FAILED": "Nem sikerült menteni a beszélgetés piszkozatát"
    },
    "MESSAGE_ERROR": "Nem tudsz üzenetet küldeni, kérlek, próbáld újra",
    "SENT_BY": "Küldő:",
    "BOT": "Bot",
    "SEND_FAILED": "Nem sikerült elküldeni az üzenetet! Próbáld újra.",
    "TRY_AGAIN": "újra",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Ügynök kiválasztása",
      "REMOVE": "Eltávolítás",
      "ASSIGN": "Hozzárendelés"
    },
    "CONTEXT_MENU": {
      "COPY": "Másolás",
      "REPLY_TO": "Válasz az üzenetre",
      "DELETE": "Törlés",
      "CREATE_A_CANNED_RESPONSE": "Mentett válasz hozzáadása",
      "TRANSLATE": "Fordítás",
      "COPY_PERMALINK": "Link másolása az üzenetbe",
      "LINK_COPIED": "Üzenet URL címe másolva lett a vágólapra",
      "FORWARD": "Továbbítás",
      "FORWARD_ERROR": "Nem sikerült előkészíteni a továbbított üzenetet",
      "DELETE_CONFIRMATION": {
        "TITLE": "Biztosan törölni szeretnéd ezt az üzenetet?",
        "MESSAGE": "Nem tudod visszavonni ezt a műveletet",
        "DELETE": "Törlés",
        "CANCEL": "Mégse"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Kontakt",
      "COPILOT": "Copilot"
    },
    "COMMENT_TREE": {
      "TITLE": "Hozzászólás szál",
      "EMPTY": "Nincsenek megjeleníthető hozzászólások",
      "VIEW_TREE": "Hozzászólás szál megtekintése"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "A beszélgetést lezárta {userName}",
          "RESOLVED_WITHOUT_CSAT": "{userName} lezárta a beszélgetést (CSAT nélkül)",
          "CONTACT_RESOLVED": "A beszélgetést megoldottra állította: {contactName}",
          "OPEN": "A beszélgetést újranyitotta {userName}",
          "PENDING": "A beszélgetést {userName} folyamatban lévőnek jelölte",
          "SNOOZED": "A beszélgetést {userName} elnémította",
          "AUTO_RESOLVED_INACTIVE": "A rendszer lezárta a beszélgetést {duration} óra inaktivitás miatt",
          "AUTO_RESOLVED": "A beszélgetést lezárta a rendszer mivel {duration} napja inaktív volt",
          "AUTO_RESOLVED_EMPTY": "A rendszer lezárta a beszélgetést, mert üres volt.",
          "SYSTEM_AUTO_OPEN": "A rendszer újranyitotta a beszélgetést egy új bejövő üzenet miatt.",
          "AUTO_REOPENED": "A rendszer a halasztási idő lejárta után újranyitotta a beszélgetést.",
          "BLOCKED_CONTACT_RESOLVED": "A rendszer lezárta a beszélgetést, mert a kapcsolattartó blokkolva van.",
          "KAUFLAND_TICKET_CLOSED": "A rendszer lezárta a beszélgetést, mert a jegyet lezárták a Kauflandon."
        },
        "PRIORITY": {
          "ADDED": "{userName} beállította a prioritást erre: {newPriority}",
          "UPDATED": "{userName} módosította a prioritást: {oldPriority} -> {newPriority}",
          "REMOVED": "{userName} eltávolított a prioritást"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} magára osztotta ezt a beszélgetést",
          "ASSIGNED": "{userName} ráosztotta a beszélgetést: {assigneeName}",
          "REMOVED": "A beszélgetést gazdátlanná tette {userName}"
        },
        "TEAM": {
          "ASSIGNED": "{userName} ráosztotta a beszélgetést: {teamName}",
          "ASSIGNED_WITH_ASSIGNEE": "Hozzárendelve ehhez: {assigneeName} ezen csoportból {teamName} általa: {userName}",
          "REMOVED": "Hozzárendelés megszüntetve: {teamName} általa: {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} a következő cimkéket adta hozzá: {labels}",
          "REMOVED": "{userName} leszedte a következő cimkéket {labels}"
        },
        "SLA": {
          "ADDED": "{userName} hozzáadta a(z) {slaName} SLA szabályzatot",
          "REMOVED": "{userName} eltávolította a(z) {slaName} SLA szabályzatot",
          "UPDATED": "{userName} frissítette a(z) {slaName} SLA szabályzatot"
        },
        "MUTED": "{userName} elnémította a beszélgetést",
        "UNMUTED": "{userName} kikapcsolta a beszélgetés elnémítását",
        "CONTACT_BLOCKED": "{userName} letiltotta a kapcsolatot",
        "CONTACT_UNBLOCKED": "{userName} feloldotta a kapcsolat letiltását",
        "DOMAIN_BLOCKED": "{userName} blokkolta az adott domain összes kapcsolattartóját",
        "DOMAIN_UNBLOCKED": "{userName} feloldotta az adott domain összes kapcsolattartójának blokkolását",
        "MERGED": "{userName} egyesítette a(z) #{sourceId} beszélgetést ebbe a beszélgetésbe",
        "MOVED": "{userName} áthelyezte ezt a beszélgetést a {sourceInboxName} postafiókból a {targetInboxName} postafiókba",
        "MOVED_BY_ORDER": "Áthelyezve, mert a kapcsolat rendelései csak a(z) {storeName} webáruházból származnak (legutóbbi rendelés: {orderId}), amelynek robotja ebben a postafiókban válaszol.",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Az üzenetküldési művelet kihagyásra került ehhez az automatikus válaszüzenethez",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Az automatizálás kihagyásra került, mert a kapcsolat le van tiltva",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "A(z) \"{ruleName}\" automatizálás nem tudta áthelyezni ezt a beszélgetést a(z) {sourceInboxName} postafiókból a(z) {targetInboxName} postafiókba, mert a postafiókok nem kompatibilisek.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "A(z) \"{ruleName}\" automatizálás nem tudta áthelyezni ezt a beszélgetést a(z) {sourceInboxName} postafiókból a(z) {targetInboxName} postafiókba, mert a kapcsolattartónak nincs e-mail-címe.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "A(z) \"{ruleName}\" automatizálás nem tudott üzenetet küldeni: ez a telefonos postafiók nem tud SMS-t küldeni, mert a fióknak nincs SMS postafiókja. A szabály ki lett kapcsolva, az adminisztrátorok pedig e-mailt kaptak.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "A(z) \"{ruleName}\" automatizálás nem tudott üzenetet küldeni: ebből a postafiókból nem lehet mellékleteket SMS-ben küldeni. A szabály ki lett kapcsolva, az adminisztrátorok pedig e-mailt kaptak.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "A(z) \"{macroName}\" makró nem küldte el az üzenetét: ez a telefonos postafiók nem tud SMS-t küldeni, mert a fióknak nincs SMS postafiókja.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "A(z) \"{macroName}\" makró nem küldte el az üzenetét: ebből a postafiókból nem lehet mellékleteket SMS-ben küldeni.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "A(z) \"{macroName}\" makró nem küldte el az üzenetét: a bot kezeli ezt a beszélgetést. Először nyissa meg a beszélgetést.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "A(z) \"{macroName}\" makró nem küldte el az üzenetét: ez a postafiók törlésre van megjelölve. Először helyezze át a beszélgetést egy másik postafiókba.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "A(z) \"{ruleName}\" automatizálás e-mailt küldött a(z) {contactEmail} címre egy új beszélgetésben ([#{conversationId}]({conversationPath})) a(z) {inboxName} postafiókban.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "A(z) \"{ruleName}\" automatizálás a(z) {inboxName} postafiók [#{conversationId}]({conversationPath}) beszélgetése miatt indította ezt a beszélgetést.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "A(z) \"{ruleName}\" automatizálás nem tudta elküldeni az üzenetet új beszélgetésben a(z) {inboxName} postafiókban, mert a kapcsolattartónak nincs e-mail-címe.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "A(z) \"{ruleName}\" automatizálás SMS-t küldött a(z) {contactPhone} számra egy új beszélgetésben ([#{conversationId}]({conversationPath})) a(z) {inboxName} postafiókban.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "A(z) \"{ruleName}\" automatizálás nem tudta elküldeni az SMS-t új beszélgetésben a(z) {inboxName} postafiókban, mert a kapcsolattartónak nincs telefonszáma.",
        "AUTOMATION_RULE_TRIGGERED": "\"{ruleName}\" automatizálási szabály elindítva",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "\"{ruleName}\" automatizálási szabály letiltotta az automatikus prioritást",
        "AUTOMATION_SKIP_AUTO_LABELING": "\"{ruleName}\" automatizálási szabály letiltotta az automatikus címkézést",
        "AUTOMATION_STOP_PROCESSING_RULES": "\"{ruleName}\" automatizálási szabály leállította a további szabályok feldolgozását",
        "AUTO_RESOLUTION_MESSAGE": "A beszélgetés megoldva, mert egy ideje inaktív volt. Kérjük, indítson új beszélgetést, ha további segítségre van szüksége.",
        "AUTO_LABELING": {
          "REASONING": "Alkalmazott címkék: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Prioritás frissítve: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Ügynök",
            "CUSTOMER": "Ügyfél"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Hívott mellékek:",
          "CALL_COMPLETED": "A hívás befejeződött",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "máshol vették fel, csengett {duration} ideig",
            "NO_ANSWER": "nem vették fel, csengett {duration} ideig",
            "REJECTED": "elutasítva, csengett {duration} ideig"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operátor",
            "QUEUE": "Várólista",
            "RING_GROUP": "Csengetési csoport"
          },
          "INBOUND_CALL": "Bejövő hívás innen: {number}, ide: {did}",
          "IVR_HANDLED": "Az IVR kezelte",
          "IVR_LABEL_NOT_FOUND": "A(z) {name} címkét szerettem volna hozzáadni, de nem létezik. Kérjük, ellenőrizze a beállításokat.",
          "CALL_MISSED": "Nem fogadott hívás",
          "CALL_NO_ANSWER": "Nincs válasz",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Automatikusan megoldva {count} sikertelen visszahívási kísérlet után",
          "OUTBOUND_CALL": "{agentName} kimenő hívása innen: {did}, ide: {number}",
          "SUMMARY_NOT_AVAILABLE": "Nem sikerült összefoglalót készíteni.",
          "RECORDING_DELETED": "Hívásrögzítés törölve: {name}, {date}"
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Beszélgetés kivonat elküldése",
    "DESC": "A beszélgetés másolatának elküldése egy megadott e-mailcímre",
    "SUBMIT": "Elküldés",
    "CANCEL": "Mégse",
    "SEND_EMAIL_SUCCESS": "A beszélgetés jegyzet sikeresen elküldve",
    "SEND_EMAIL_ERROR": "Hiba történt, kérjük próbáld újra",
    "FORM": {
      "SEND_TO_CONTACT": "A beszélgetés jegyzet elküldése az ügyfélnek",
      "SEND_TO_AGENT": "A beszélgetés jegyzet elküldése a hozzárendelt ügynöknek",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Küldj jegyzetet egy másik e-mailcímre",
      "EMAIL": {
        "PLACEHOLDER": "E-mailcím megadása",
        "ERROR": "Kérjük helyes e-mailcímet adj meg"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hello 👋, köszöntünk a {installationName}!",
    "DESCRIPTION": "Köszönjük, hogy feliratkoztál. Segíteni akarunk, hogy a legtöbbet hozd ki a {installationName}. Itt találsz egy pár dolgot, amit a {installationName} lehetővé tesz.",
    "GREETING_MORNING": "👋 Jó reggelt, {name}! Üdvözöljük a(z) {installationName} rendszerben.",
    "GREETING_AFTERNOON": "👋 Jó napot, {name}! Üdvözöljük a(z) {installationName} rendszerben.",
    "GREETING_EVENING": "👋 Jó estét, {name}! Üdvözöljük a(z) {installationName} rendszerben.",
    "READ_LATEST_UPDATES": "Olvasd el legfrissebbeket",
    "ALL_CONVERSATION": {
      "TITLE": "Minden beszélgetésed egy helyen",
      "DESCRIPTION": "Kövesd az összes ügyfélbeszélgetésedet egy felületről. Szűrheted a beszélgetéseket csatorna, cimke vagy státusz alapján.",
      "NEW_LINK": "Kattints ide postaláda létrehozásához"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Hívd meg csapattagjaidat",
      "DESCRIPTION": "Mivel éppen ügyféllel készülsz beszélni, hívd meg a csapattagjaidat, hogy segíthessenek neked. Az e-mailcímük ügynöklistába való megadásával tudod meghívni őket.",
      "NEW_LINK": "Kattints ide csapattag meghívásához"
    },
    "LABELS": {
      "TITLE": "Rendezd a beszélgetéseket cimkékkel",
      "DESCRIPTION": "A cimkék egyszerű módot biztosítanak hogy kategorizáld a beszélgetést. Hozz létre cimkéket, mint például a #támogatás vagy a #számlázás, stb... későbbi használatra.",
      "NEW_LINK": "Kattints ide cimkék létrehozásához"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Mentett válaszok létrehozása",
      "DESCRIPTION": "Az előre megírt gyorsválasz-sablonokkal gyorsan válaszolhat egy beszélgetésben. Az ügynökök a '/' karakter és a rövid kód beírásával szúrhatnak be választ.",
      "NEW_LINK": "Kattintson ide mentett válasz létrehozásához"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Hozzárendelt ügynök",
    "SELF_ASSIGN": "Hozzárendelés magamhoz",
    "TEAM_LABEL": "Hozzárendelt csapat",
    "SELECT": {
      "PLACEHOLDER": "Nincs"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Egyéni adatok",
      "ORDER_HISTORY": "Rendelési előzmények",
      "CONTACT_DETAILS": "Kontakt adatai",
      "CONVERSATION_ACTIONS": "Beszélgetés Műveletek",
      "CONVERSATION_LABELS": "Beszélgetés cimkék",
      "CONVERSATION_INFO": "Beszélgetés Információk",
      "CONTACT_ATTRIBUTES": "Kontakt Tulajdonságok",
      "PREVIOUS_CONVERSATION": "Korábbi beszélgetések",
      "MACROS": "Makrók",
      "RETINO_TICKETS": "Retino jegyek",
      "SHOPIFY_ORDERS": "Shopify rendelések"
    },
    "SHOPIFY": {
      "ORDER_ID": "Rendelés #{id}",
      "ERROR": "Hiba a rendelések betöltésekor",
      "NO_SHOPIFY_ORDERS": "Nincs rendelés",
      "FINANCIAL_STATUS": {
        "PENDING": "Függőben lévő",
        "AUTHORIZED": "Engedélyezve",
        "PARTIALLY_PAID": "Részben fizetve",
        "PAID": "Fizetve",
        "PARTIALLY_REFUNDED": "Részben visszatérítve",
        "REFUNDED": "Visszatérítve",
        "VOIDED": "Érvénytelenítve"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Teljesítve",
        "PARTIALLY_FULFILLED": "Részben teljesítve",
        "UNFULFILLED": "Nincs teljesítve"
      }
    }
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "Nem található adat",
    "LOAD_ERROR": "Nem sikerült betölteni az adatokat. Kérjük, próbálja újra később."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Több betöltése",
    "NO_RECORDS_FOUND": "Nem találhatók jegyek",
    "LOAD_ERROR": "Nem sikerült betölteni a jegyeket innen: {hookName}. Kérjük, próbálja újra később.",
    "NOT_SEARCHABLE": "A kapcsolattartó e-mail címe nincs beállítva.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Betöltés...",
    "NO_ORDERS": "Nem találhatók rendelések",
    "NOT_AVAILABLE": "Ügyféladatok nem elérhetők",
    "EXPAND": "Ügyfélprofil megnyitása",
    "MORE_ITEMS": "+ {count} elem",
    "EXPEDITION_STATUS": "Szállítási állapot",
    "OPEN_DETAIL": "részletek megnyitása",
    "COPY_ORDER_ID": "Rendelésszám",
    "EXTERNAL_ID": "Külső azonosító",
    "PAYMENT_TYPE": "Fizetési mód",
    "PAYMENT_DATE": "Fizetés dátuma",
    "DELIVERY_PROVIDER": "Szállító",
    "EXPECTED_DATE_OF_DELIVERY": "Várható kézbesítés",
    "DATE_OF_DELIVERY": "Kézbesítve",
    "EXPEDITION_DATE": "Feladás dátuma",
    "INTERNAL_NOTE": "Bolti megjegyzés",
    "PACKAGE_NUMBER": "Csomag"
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Attribútum hozzáadása",
    "NO_RECORDS_FOUND": "Nem található tulajdonság",
    "UPDATE": {
      "SUCCESS": "Tulajdonság sikeresen frissítve",
      "ERROR": "Nem lehet frissíteni a tulajdonságot. Kérlek, próbáld újra"
    },
    "ADD": {
      "TITLE": "Hozzáadás",
      "SUCCESS": "Tulajdonság sikeresen hozzáadva",
      "ERROR": "Nem lehet hozzáadni a tulajdonságot. Kérlek, próbáld újra"
    },
    "DELETE": {
      "SUCCESS": "Tulajdonság sikeresen törölve",
      "ERROR": "Nem lehet törölni a tulajdonságot. Kérlek, próbáld újra"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Attribútum hozzáadása",
      "PLACEHOLDER": "Attribútumok keresése",
      "NO_RESULT": "Nem található attribútum"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Innen",
    "TO": "Ide",
    "BCC": "Titkos másolat",
    "CC": "Másolat",
    "SUBJECT": "Tárgy"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Részvétel",
    "SIDEBAR_TITLE": "Résztvevők",
    "NO_RECORDS_FOUND": "Nincs találat",
    "ADD_PARTICIPANTS": "Résztvevők kiválasztása",
    "REMANING_PARTICIPANTS_TEXT": "+{count} fő",
    "REMANING_PARTICIPANT_TEXT": "+{count} fő",
    "TOTAL_PARTICIPANTS_TEXT": "+{count} fő vesz részt.",
    "TOTAL_PARTICIPANT_TEXT": "+{count} fő vesz részt.",
    "NO_PARTICIPANTS_TEXT": "Nincs részvevő!.",
    "WATCH_CONVERSATION": "Csatlakozás a beszélgetéshez",
    "YOU_ARE_WATCHING": "Te részt veszel",
    "API": {
      "ERROR_MESSAGE": "Nem sikerült frissítenbi, próbálja újra később!",
      "SUCCESS_MESSAGE": "Résztvevők frissítve!"
    },
    "SEARCH_PLACEHOLDER": "Keresés"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Fordított szöveg megtekintése",
    "DESC": "Meg tudod nézni a fordított tartalmat minden nyelven.",
    "ORIGINAL_CONTENT": "Eredeti szöveg",
    "TRANSLATED_CONTENT": "Fordított szöveg",
    "NO_TRANSLATIONS_AVAILABLE": "Nem elérhető fordítás ehhez a tartalomhoz"
  },
  "TYPING": {
    "ONE": "{user} éppen ír",
    "TWO": "{user} és {secondUser} éppen ír",
    "MULTIPLE": "{user} és további {count} személy éppen ír",
    "IMAGE_ALT": "Valaki éppen gépel"
  },
  "READING": {
    "ONE": "{user} olvassa ezt a jegyet",
    "TWO": "{user} és {secondUser} olvassa ezt a jegyet",
    "MULTIPLE": "{user} és még {count} másik olvassa ezt a jegyet"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Próbálja ki ezeket a promptokat"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Beszélgetés áthelyezése",
    "DESCRIPTION": "Helyezze át ezt a beszélgetést egy másik e-mail postafiókba.",
    "SOURCE": {
      "TITLE": "Beszélgetés",
      "ID_LABEL": "Beszélgetés azonosítója"
    },
    "TARGET": {
      "TITLE": "Cél postafiók",
      "PLACEHOLDER": "Válasszon ki egy e-mail postafiókot",
      "NO_RESULTS": "Nincs más elérhető e-mail postafiók",
      "ERROR": "Kérjük, válasszon ki egy cél postafiókot"
    },
    "SUBMIT": "Beszélgetés áthelyezése",
    "CANCEL": "Mégse",
    "SUCCESS_MESSAGE": "A beszélgetés sikeresen áthelyezve",
    "ERROR_MESSAGE": "Nem sikerült áthelyezni a beszélgetést. Kérjük, próbálja újra."
  },
  "MERGE": {
    "TITLE": "Beszélgetések egyesítése",
    "DESCRIPTION": "Egyesítse ezt a beszélgetést egy másik beszélgetéssel. A beszélgetésből származó összes üzenet átkerül a cél beszélgetésbe, és ez a beszélgetés törlődik.",
    "SOURCE": {
      "TITLE": "Forrás beszélgetés (törölve lesz)",
      "ID_LABEL": "Beszélgetés azonosítója"
    },
    "TARGET": {
      "TITLE": "Cél beszélgetés",
      "PLACEHOLDER": "Írja be a beszélgetés azonosítóját a kereséshez (pl. 123)",
      "HELP": "Adja meg a beszélgetés azonosítóját, amelybe az összes üzenetet egyesíteni szeretné.",
      "ERROR": "Kérjük, válasszon ki egy cél beszélgetést"
    },
    "WARNING": "Figyelem: Ez a művelet nem vonható vissza. Az összes üzenet átkerül a cél beszélgetésbe, és ez a beszélgetés véglegesen törlődik.",
    "SUBMIT": "Beszélgetések egyesítése",
    "CANCEL": "Mégse",
    "SUCCESS_MESSAGE": "A beszélgetés sikeresen egyesítve",
    "ERROR_MESSAGE": "Nem sikerült egyesíteni a beszélgetéseket. Ellenőrizze a cél beszélgetést, és próbálja újra.",
    "SEARCH": {
      "NO_RESULTS": "Nem található beszélgetés ezzel az azonosítóval",
      "ERROR_MESSAGE": "Nem sikerült a beszélgetések keresése. Kérjük, próbálja újra."
    },
    "CONFIRM": {
      "TITLE": "Egyesítés megerősítése",
      "DESCRIPTION": "Biztosan egyesíteni szeretné ezt a beszélgetést? Ez a művelet nem vonható vissza.",
      "YES": "Igen, egyesítés",
      "CANCEL": "Mégse"
    }
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "A melléklet letöltése nem sikerült. Kérjük, próbálja újra"
  }
}
